var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-tile"},[_c('aspect-ratio',_vm._b({staticClass:"icon-tile-tile",attrs:{"tag":"a","ratio":"2x1"}},'aspect-ratio',_vm.$attrs,false),[_c('lazy-icon',{attrs:{"icon":_vm.iconName}}),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._t("default")],2)],1),_c('div',{staticClass:"icon-tile-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }